function stopSpacebar() {
  document.addEventListener('keydown', (e) => {
    if (e.key === ' ') {
      e.preventDefault();
      // get the current active element and click on it - if exists
      const link = document.activeElement.closest('a');
      if (link) {
        link.click();
      }
    }
  }, false);
}

export default stopSpacebar;
